import MoneyRange from './MoneyRange'

export default MoneyRange
